import React from "react";
import ArchiveStickySelector from "./ArchiveStickySelector";
import Sticky from "react-stickynode";
import sizeMe, { SizeMe } from "react-sizeme";
import useWindowDimensions from "../utils/useWindowDimensions";

function ArchiveSticky({ years, onStateChange }) {
  const windowHeight = useWindowDimensions().height;
  return (
    <SizeMe monitorHeight>
      {({ size }) => (
        <Sticky
          enabled={true}
          top={windowHeight / 2 - size.height / 2}
          onStateChange={() => {onStateChange(size.height)}}
          bottomBoundary='#stop-sticky'
        >
          <div className="hidden lg:block">
            <div className="container">
              <div className="ml-auto w-1/12">
                <ArchiveStickySelector years={years} />
              </div>
            </div>
          </div>
        </Sticky>
      )}
    </SizeMe>
  );
}

export default sizeMe({ monitorHeight: true })(ArchiveSticky);
